function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "money-house-building-home"
}, /*#__PURE__*/React.createElement("path", {
  d: "M61,28H39V25.24l1.61.68A1.087,1.087,0,0,0,41,26a1.011,1.011,0,0,0,1-1V21a.993.993,0,0,0-.61-.92L35,17.39V11a1,1,0,0,0-1-1H29a1,1,0,0,0-1,1v3.44l-5.61-2.36a.963.963,0,0,0-.78,0l-19,8A.993.993,0,0,0,2,21v4a1,1,0,0,0,.45.83.985.985,0,0,0,.94.09L5,25.24V44H4a1,1,0,0,0-1,1v4a1,1,0,0,0,1,1H15V61a1,1,0,0,0,1,1H54a1,1,0,0,0,1-1V50h6a1,1,0,0,0,1-1V29A1,1,0,0,0,61,28ZM30,12h3v4.55l-3-1.27ZM4,23.49V21.66l18-7.58,18,7.58v1.83L22.39,16.08a.991.991,0,0,0-.78,0ZM25,28a1,1,0,0,0-1,1v3.35A5.845,5.845,0,0,0,22,32a6,6,0,0,0-6,6v6H7V24.4l15-6.32L37,24.4V28Zm3.86,2A4.017,4.017,0,0,1,26,32.86V30ZM24,34.54V44H18V38a4,4,0,0,1,4-4A3.944,3.944,0,0,1,24,34.54ZM5,48V46H24v2ZM27,60H17V59H27Zm0-3H17V56H27Zm0-3H17V53H27Zm0-3H17V50H27Zm-1-3V45.14A4.017,4.017,0,0,1,28.86,48ZM41,60H29V50H41Zm12,0H43V59H53Zm0-3H43V56H53Zm0-3H43V53H53Zm0-3H43V50H53Zm7-3H57.14A4.017,4.017,0,0,1,60,45.14Zm0-4.91A5.992,5.992,0,0,0,55.09,48H30.91A5.992,5.992,0,0,0,26,43.09V34.91A5.992,5.992,0,0,0,30.91,30H55.09A5.992,5.992,0,0,0,60,34.91Zm0-10.23A4.017,4.017,0,0,1,57.14,30H60Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 31,
  y: 38,
  width: 3,
  height: 2
}), /*#__PURE__*/React.createElement("rect", {
  x: 52,
  y: 38,
  width: 3,
  height: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.5,37h1a.5.5,0,0,1,.5.5h2a2.5,2.5,0,0,0-2-2.449V34H42v1.051A2.5,2.5,0,0,0,42.5,40h1a.5.5,0,0,1,0,1h-1a.5.5,0,0,1-.5-.5H40a2.5,2.5,0,0,0,2,2.449V44h2V42.949A2.5,2.5,0,0,0,43.5,38h-1a.5.5,0,0,1,0-1Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43,31a8,8,0,1,0,8,8A8.009,8.009,0,0,0,43,31Zm0,14a6,6,0,1,1,6-6A6.006,6.006,0,0,1,43,45Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16,32a1,1,0,0,0,1-1V26a1,1,0,0,0-1-1H10a1,1,0,0,0-1,1v5a1,1,0,0,0,1,1Zm-5-5h4v3H11Z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 19,
  y: 39,
  width: 2,
  height: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M44,16a3.942,3.942,0,0,0,2.541-.919,7.1,7.1,0,0,0,7.294-.23A4.95,4.95,0,0,0,57,16a5,5,0,1,0-.65-9.952A7,7,0,0,0,43.056,8.112,4,4,0,0,0,44,16Zm0-6a1,1,0,0,0,1-1,5,5,0,0,1,9.777-1.48,1,1,0,0,0,1.275.652A2.952,2.952,0,0,1,57,8,3,3,0,1,1,54.7,12.9a1,1,0,0,0-.688-.361l-.083,0a1,1,0,0,0-.655.244A5.076,5.076,0,0,1,47,12.99a1,1,0,0,0-1.4.2A1.979,1.979,0,0,1,44,14a2,2,0,0,1,0-4Z"
}));

var SvgCasa = function SvgCasa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    width: 40,
    height: 40,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCasa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/casa.54c16802.svg";
export { ForwardRef as ReactComponent };